// extracted by mini-css-extract-plugin
module.exports = {"root":"root___3kvlZ","text":"text___1QEwm","smallTextBelowPhablet":"smallTextBelowPhablet___UhdmN","smallTextBelowPhone":"smallTextBelowPhone___6PNP6","loading":"loading___3Ybj6"};